export const styles = {
  successButton: {
    width: "100%",
  },
};
